import { ColumnMapping } from '@/components/ExcelExportModal'

export const SERVICE_EXCEL_COLUMNS: ColumnMapping[] = [
    { header: 'customer_id', data_field: 'customer_id', width: 10 },
    { header: 'company_name', data_field: 'company_name', width: 30 },
    { header: 'customer_name', data_field: 'customer_name', width: 30 },
    {
        header: 'product_group_name',
        data_field: 'product_group_name',
        width: 30,
    },
    { header: 'service_id', data_field: 'service_id', width: 15 },
    { header: 'service_name', data_field: 'service_name', width: 20 },
    {
        header: 'employee_sale_tracking_ids',
        data_field: 'employee_sale_tracking_ids',
    },
    { header: 'entity-name', data_field: 'name', width: 20 },
    {
        header: 'cs_followers',
        data_field: 'cs_followers',
        width: 20,
        formatter_type: 'array_join',
        formatter_options: { separator: ', ' },
    },
    {
        header: 'sale_followers',
        data_field: 'sale_followers',
        width: 20,
        formatter_type: 'array_join',
        formatter_options: { separator: ', ' },
    },
    {
        header: 'service_status',
        data_field: 'service_status',
        width: 30,
        formatter_type: 'service_status',
    },
    { header: 'current_startdate', data_field: 'current_startdate', width: 30 },
    { header: 'current_enddate', data_field: 'current_enddate', width: 30 },
    {
        header: 'continue_startdate',
        data_field: 'continue_startdate',
        width: 30,
    },
    { header: 'continue_enddate', data_field: 'continue_enddate', width: 30 },
    {
        header: 'service_start_date',
        data_field: 'service_start_date',
        width: 30,
        formatter_type: 'date',
    },
    {
        header: 'service_stopped_date',
        data_field: 'service_stopped_date',
        width: 30,
        formatter_type: 'date',
    },
    {
        header: 'created_at',
        data_field: 'created_at',
        width: 30,
        formatter_type: 'date',
    },
]
